// import React, { useState } from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";
// import { styled } from "@mui/material/styles";

// const modalStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "1400px",
//   bgcolor: "background.paper",
//   borderRadius: "8px",
//   boxShadow: 24,
//   p: 4,
// };

// export default function Terms() {
//   const [open, setOpen] = useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   return (
//     <div className="flex justify-center items-center">
//       <Button
//         onClick={handleOpen}
//         className="bg-orange-600 text-white py-2 px-4 rounded"
//       >
//         Open Terms and Conditions
//       </Button>
//       <Modal open={open} onClose={handleClose} aria-labelledby="terms-title">
//         <Box sx={modalStyle}>
//           <Typography
//             id="terms-title"
//             variant="h6"
//             className="text-center bg-orange-600 text-white py-2 rounded-t "
//           >
//             Terms and Conditions
//           </Typography>
//           <div className="p-4 text-gray-700">
//             <ul className="list-disc list-inside space-y-2">
//               <li>
//                 A ride cannot commence until and unless the required documents
//                 are uploaded and verified.{" "}
//                 <a href="#" className="text-blue-600 underline">
//                   Cancellation policy
//                 </a>{" "}
//                 will apply if proper documents are not uploaded for
//                 verification.
//               </li>
//               <li>
//                 Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
//                 specified by the governing authority, whichever is lesser.
//               </li>
//               <li>
//                 Rental package does not include Fuel, Toll, State Permits or
//                 Taxes.
//               </li>
//               <li>
//                 Km’s included in the booking if exceeded are chargeable at a per
//                 km rate.
//               </li>
//               <li>
//                 Some vehicle bookings have a refundable security deposit. Refund
//                 of the same, usually takes 3-7 working days, from the date of
//                 invoice, to reflect in the source account.
//               </li>
//               <li>Delay Drop off Charges :</li>
//             </ul>
//           </div>
//           <div className="border-t p-4 flex flex-col space-y-2">
//             <label className="flex items-center space-x-2">
//               <Checkbox />
//               <span>Terms and Conditions</span>
//             </label>
//             <label className="flex items-center space-x-2">
//               <Checkbox />
//               <span>Terms and Conditions</span>
//             </label>
//             <Button
//               onClick={handleClose}
//               className="bg-orange-600 text-white py-2 rounded mt-4"
//               disabled
//             >
//               PROCEED
//             </Button>
//           </div>
//         </Box>
//       </Modal>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";

// export default function Terms() {
//   const [open, setOpen] = useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   return (
//     <div className="flex justify-center items-center">
//       <Button
//         onClick={handleOpen}
//         className="bg-orange-600 text-white py-2 px-4 rounded"
//       >
//         Open Terms and Conditions
//       </Button>
//       <Modal open={open} onClose={handleClose} aria-labelledby="terms-title">
//         <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl bg-white rounded-lg shadow-lg p-4">
//           <Typography
//             id="terms-title"
//             variant="h6"
//             className="text-center bg-orange-600 text-white py-2 rounded-t"
//           >
//             Terms and Conditions
//           </Typography>
//           <div className="p-4 text-gray-700">
//             <ul className="list-disc list-inside space-y-2">
//               <li>
//                 A ride cannot commence until and unless the required documents
//                 are uploaded and verified.{" "}
//                 <a href="#" className="text-blue-600 underline">
//                   Cancellation policy
//                 </a>{" "}
//                 will apply if proper documents are not uploaded for
//                 verification.
//               </li>
//               <li>
//                 Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
//                 specified by the governing authority, whichever is lesser.
//               </li>
//               <li>
//                 Rental package does not include Fuel, Toll, State Permits or
//                 Taxes.
//               </li>
//               <li>
//                 Km’s included in the booking if exceeded are chargeable at a per
//                 km rate.
//               </li>
//               <li>
//                 Some vehicle bookings have a refundable security deposit. Refund
//                 of the same, usually takes 3-7 working days, from the date of
//                 invoice, to reflect in the source account.
//               </li>
//               <li>Delay Drop off Charges :</li>
//             </ul>
//           </div>
//           <div className="border-t p-4 flex flex-col space-y-2">
//             <label className="flex items-center space-x-2">
//               <Checkbox />
//               <span>Agree to Terms and Conditions</span>
//             </label>
//             <label className="flex items-center space-x-2">
//               <Checkbox />
//               <span>Agree to Privacy Policy</span>
//             </label>
//             <Button
//               onClick={handleClose}
//               className="bg-orange-600 text-white py-2 rounded mt-4"
//               disabled
//             >
//               PROCEED
//             </Button>
//           </div>
//         </Box>
//       </Modal>
//     </div>
//   );
// }


// import React, { useState } from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";

// export default function Terms() {
//   const [open, setOpen] = useState(false);
//   const [termsChecked, setTermsChecked] = useState(false); // State for Terms checkbox
//   const [privacyChecked, setPrivacyChecked] = useState(false); // State for Privacy checkbox

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   // Handle checkbox change for Terms and Conditions
//   const handleTermsChange = (event) => {
//     setTermsChecked(event.target.checked);
//   };

//   // Handle checkbox change for Privacy Policy
//   const handlePrivacyChange = (event) => {
//     setPrivacyChecked(event.target.checked);
//   };

//   // Check if both checkboxes are checked
//   const isFormValid = termsChecked && privacyChecked;

//   return (
//     <>
//     <div className="flex justify-center items-center">
//       <Button
//         onClick={handleOpen}
//         className="bg-orange-600 text-white py-2 px-4 rounded"
//       >
//         Open Terms and Conditions
//       </Button>
//       <Modal open={open} onClose={handleClose} aria-labelledby="terms-title">
//         <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl bg-white rounded-lg shadow-lg p-4">
//           <Typography
//             id="terms-title"
//             variant="h6"
//             className="text-center bg-orange-600 text-white py-2 rounded-t"
//           >
//             Terms and Conditions
//           </Typography>
//           <div className="p-4 text-gray-700">
//             <ul className="list-disc list-inside space-y-2">
//               <li>
//                 A ride cannot commence until and unless the required documents
//                 are uploaded and verified.{" "}
//                 <a href="#" className="text-red-600 underline">
//                   Cancellation policy
//                 </a>{" "}
//                 will apply if proper documents are not uploaded for
//                 verification.
//               </li>
//               <li>
//                 Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
//                 specified by the governing authority, whichever is lesser.
//               </li>
//               <li>
//                 Rental package does not include Fuel, Toll, State Permits or
//                 Taxes.
//               </li>
//               <li>
//                 Km’s included in the booking if exceeded are chargeable at a per
//                 km rate.
//               </li>
//               <li>
//                 Some vehicle bookings have a refundable security deposit. Refund
//                 of the same, usually takes 3-7 working days, from the date of
//                 invoice, to reflect in the source account.
//               </li>
//               <li>Delay Drop off Charges :</li>
//             </ul>
//           </div>
//           <div className="border-t p-4 flex flex-col space-y-2">
//             <label className="flex items-center space-x-2">
//               <Checkbox
//                 checked={termsChecked}
//                 onChange={handleTermsChange}
//               />
//               <span>Agree to Terms and Conditions</span>
//             </label>
//             <label className="flex items-center space-x-2">
//               <Checkbox
//                 checked={privacyChecked}
//                 onChange={handlePrivacyChange}
//               />
//               <span>Agree to Privacy Policy</span>
//             </label>
//             {/* <Button
//               onClick={handleClose}
//               className={`py-2 rounded mt-4 ${isFormValid ? 'bg-green-600' : 'bg-orange-600'} text-white`}
//               disabled={!isFormValid} // Disable button if either checkbox is not checked
//             >
//               PROCEED
//             </Button> */}
//              <Box
//               className={`absolute right-4 bottom-4 p-2 rounded border-2 ${isFormValid ? 'bg-orange-600' : 'bg-orange-600'} border-orange-600`}
//             >
//               <Button
//                 onClick={handleClose}
//                 className="py-2 px-4 rounded text-white"
//                 disabled={!isFormValid} // Disable button if either checkbox is not checked
//               >
//                 PROCEED
//               </Button>
//             </Box>
//           </div>
//         </Box>
//       </Modal>
//     </div>
//     </>
//   );
// }


// import React, { useState } from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";

// export default function Terms() {
//   const [open, setOpen] = useState(false);
//   const [termsChecked, setTermsChecked] = useState(false); // State for Terms checkbox
//   const [privacyChecked, setPrivacyChecked] = useState(false); // State for Privacy checkbox

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   // Handle checkbox change for Terms and Conditions
//   const handleTermsChange = (event) => {
//     setTermsChecked(event.target.checked);
//   };

//   // Handle checkbox change for Privacy Policy
//   const handlePrivacyChange = (event) => {
//     setPrivacyChecked(event.target.checked);
//   };

//   // Check if both checkboxes are checked
//   const isFormValid = termsChecked && privacyChecked;

//   return (
//     <>
//       <div className="flex justify-center items-center">
//         <Button
//           onClick={handleOpen}
//           className="bg-orange-600 text-white py-2 px-4 rounded"
//         >
//           Open Terms and Conditions
//         </Button>
//         <Modal open={open} onClose={handleClose} aria-labelledby="terms-title">
//           <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl bg-white rounded-lg shadow-lg ">
//             <Typography
//               id="terms-title"
//               variant="h6"
//               className="text-center bg-orange-600 text-white py-2 rounded-t"
//             >
//               Terms and Conditions
//             </Typography>

//             {/* Separate div for Terms and Conditions content without padding */}
//             <div className="text-gray-700 p-4">
//               <ul className="list-disc list-inside space-y-2">
//                 <li>
//                   A ride cannot commence until and unless the required documents
//                   are uploaded and verified.{" "}
//                   <a href="#" className="text-red-600 underline">
//                     Cancellation policy
//                   </a>{" "}
//                   will apply if proper documents are not uploaded for
//                   verification.
//                 </li>
//                 <li>
//                   Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
//                   specified by the governing authority, whichever is lesser.
//                 </li>
//                 <li>
//                   Rental package does not include Fuel, Toll, State Permits or
//                   Taxes.
//                 </li>
//                 <li>
//                   Km’s included in the booking if exceeded are chargeable at a per
//                   km rate.
//                 </li>
//                 <li>
//                   Some vehicle bookings have a refundable security deposit. Refund
//                   of the same, usually takes 3-7 working days, from the date of
//                   invoice, to reflect in the source account.
//                 </li>
//                 <li>Delay Drop off Charges :</li>
//                 <li>
//                   Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.
//                 </li>
//                 <li>
//                   THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES.
//                   THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.
//                 </li>
//               </ul>
//             </div>

//             {/* <div className="border-t p-4 flex flex-col space-y-2">
//               <label className="flex items-center space-x-2">
//                 <Checkbox
//                   checked={termsChecked}
//                   onChange={handleTermsChange}
//                 />
//                 <span>Agree to Terms and Conditions</span>
//               </label>
//               <label className="flex items-center space-x-2">
//                 <Checkbox
//                   checked={privacyChecked}
//                   onChange={handlePrivacyChange}
//                 />
//                 <span>Agree to Privacy Policy</span>
//               </label>

//               <Box
//                 className={`absolute right-4 bottom-4 p-2 rounded border-2 ${isFormValid ? 'bg-orange-600' : 'bg-orange-600'} border-orange-600`}
//               >
//                 <Button
//                   onClick={handleClose}
//                   className="py-2 px-4 rounded text-white"
//                   disabled={!isFormValid} // Disable button if either checkbox is not checked
//                 >
//                   PROCEED
//                 </Button>
//               </Box>
//             </div> */}
//             <div className="border-t p-4 flex flex-col space-y-2">
//               <Box className="flex flex-col space-y-2">
//                 {/* Terms and Privacy Policy Checkboxes */}
//                 <label className="flex items-center space-x-2">
//                   <Checkbox checked={termsChecked} onChange={handleTermsChange} />
//                   <span>Agree to Terms and Conditions</span>
//                 </label>
//                 <label className="flex items-center space-x-2">
//                   <Checkbox checked={privacyChecked} onChange={handlePrivacyChange} />
//                   <span>Agree to Privacy Policy</span>
//                 </label>
//               </Box>

//               {/* Proceed Button Box */}
//               <Box
//                 className={`absolute right-4 bottom-4 p-2 rounded border-2 ${isFormValid ? 'bg-orange-600' : 'bg-gray-400'} border-orange-600`}
//               >
//                 <Button
//                   onClick={handleClose}
//                   className="py-2 px-4 rounded text-white"
//                   disabled={!isFormValid} // Disable button if either checkbox is not checked
//                 >
//                   PROCEED
//                 </Button>
//               </Box>
//             </div>

//           </Box>
//         </Modal>
//       </div>
//     </>
//   );
// }



// import React, { useState } from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";

// export default function Terms() {
//   const [open, setOpen] = useState(false);
//   const [termsChecked, setTermsChecked] = useState(false);
//   const [privacyChecked, setPrivacyChecked] = useState(false);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const handleTermsChange = (event) => {
//     setTermsChecked(event.target.checked);
//   };

//   const handlePrivacyChange = (event) => {
//     setPrivacyChecked(event.target.checked);
//   };

//   const isFormValid = termsChecked && privacyChecked;

//   return (
//     <>
//       <div className="flex justify-center items-center">
//         <Button
//           onClick={handleOpen}
//           className="bg-orange-600 text-white py-2 px-4 rounded"
//         >
//           Open Terms and Conditions
//         </Button>
//         <Modal open={open} onClose={handleClose} aria-labelledby="terms-title">
//           <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl bg-white rounded-lg shadow-lg">
//             <Typography
//               id="terms-title"
//               variant="h6"
//               className="text-center bg-orange-600 text-white py-2 rounded-t"
//             >
//               Terms and Conditions
//             </Typography>

//             {/* Scrollable Terms and Conditions content */}
//             <div className="text-gray-700 p-4 max-h-64 overflow-y-auto">
//               <ul className="list-disc list-inside space-y-2">
//                 <li>
//                   A ride cannot commence until and unless the required documents
//                   are uploaded and verified.{" "}
//                   <a href="#" className="text-red-600 underline">
//                     Cancellation policy
//                   </a>{" "}
//                   will apply if proper documents are not uploaded for
//                   verification.
//                 </li>
//                 <li>
//                   Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
//                   specified by the governing authority, whichever is lesser.
//                 </li>
//                 <li>
//                   Rental package does not include Fuel, Toll, State Permits or
//                   Taxes.
//                 </li>
//                 <li>
//                   Km’s included in the booking if exceeded are chargeable at a per
//                   km rate.
//                 </li>
//                 <li>
//                   Some vehicle bookings have a refundable security deposit. Refund
//                   of the same, usually takes 3-7 working days, from the date of
//                   invoice, to reflect in the source account.
//                 </li>
//                 <li>Delay Drop off Charges :</li>
//                 <li>
//                   Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.
//                 </li>
//                 <li>
//                   THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES.
//                   THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.
//                 </li>
//               </ul>
//             </div>

//             {/* Fixed Checkboxes and Proceed Button */}
//             <div className="border-t p-4">
//               <Box className="flex flex-col space-y-2">
//                 <label className="flex items-center space-x-2">
//                   <Checkbox checked={termsChecked} onChange={handleTermsChange} />
//                   <span>Agree to Terms and Conditions</span>
//                 </label>
//                 <label className="flex items-center space-x-2">
//                   <Checkbox checked={privacyChecked} onChange={handlePrivacyChange} />
//                   <span>Agree to Privacy Policy</span>
//                 </label>
//               </Box>

//                 <Button
//                   onClick={handleClose}
//                   className=" py-2 px-4 rounded "
//                   disabled={!isFormValid}
//                   sx={{
//                     color: isFormValid ? 'gray' : 'white', // Set to gray when enabled
//                     backgroundColor: isFormValid ? 'orange' : 'gray',
//                     '&:hover': {
//                       backgroundColor: isFormValid ? 'darkorange' : 'gray',
//                     },
//                   }}
//                 >
//                   PROCEED
//                 </Button>
//             </div>
//           </Box>
//         </Modal>
//       </div>
//     </>
//   );
// }


// import React, { useState } from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";

// export default function Terms() {
//   const [open, setOpen] = useState(false);
//   const [termsChecked, setTermsChecked] = useState(false);
//   const [privacyChecked, setPrivacyChecked] = useState(false);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const handleTermsChange = (event) => {
//     setTermsChecked(event.target.checked);
//   };

//   const handlePrivacyChange = (event) => {
//     setPrivacyChecked(event.target.checked);
//   };

//   const isFormValid = termsChecked && privacyChecked;

//   return (
//     <>
//       <div className="flex justify-center items-center">
//         <Button
//           onClick={handleOpen}
//           className="bg-orange-600 text-white py-2 px-4 rounded"
//         >
//           Open Terms and Conditions
//         </Button>
//         <Modal open={open} onClose={handleClose} aria-labelledby="terms-title">
//           <Box className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl bg-white rounded-lg shadow-lg">
//             <Typography
//               id="terms-title"
//               variant="h6"
//               className="text-center bg-orange-600 text-white py-2 rounded-t"
//             >
//               Terms and Conditions
//             </Typography>

//             {/* Scrollable Terms and Conditions content */}
//             <div className="text-gray-700 p-4 max-h-64 overflow-y-auto">
//               <ul className="list-disc list-inside space-y-2">
//                 <li>
//                   A ride cannot commence until and unless the required documents
//                   are uploaded and verified.{" "}
//                   <a href="#" className="text-red-600 underline">
//                     Cancellation policy
//                   </a>{" "}
//                   will apply if proper documents are not uploaded for
//                   verification.
//                 </li>
//                 <li>
//                   Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
//                   specified by the governing authority, whichever is lesser.
//                 </li>
//                 <li>
//                   Rental package does not include Fuel, Toll, State Permits or
//                   Taxes.
//                 </li>
//                 <li>
//                   Km’s included in the booking if exceeded are chargeable at a per
//                   km rate.
//                 </li>
//                 <li>
//                   Some vehicle bookings have a refundable security deposit. Refund
//                   of the same, usually takes 3-7 working days, from the date of
//                   invoice, to reflect in the source account.
//                 </li>
//                 <li>Delay Drop off Charges :</li>
//                 <li>
//                   Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.
//                 </li>
//                 <li>
//                   THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES.
//                   THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.
//                 </li>
//               </ul>
//             </div>

//             {/* Fixed Checkboxes and Proceed Button */}
//             <div className="border-t p-4 flex flex-col">
//               <Box className="flex flex-col ">
//                 <label className="flex items-center ">
//                   <Checkbox checked={termsChecked} onChange={handleTermsChange} />
//                   <span>Agree to Terms and Conditions</span>
//                 </label>
//                 <label className="flex items-center">
//                   <Checkbox checked={privacyChecked} onChange={handlePrivacyChange} />
//                   <span>Agree to Privacy Policy</span>
//                 </label>
//               </Box>

//               {/* Right-aligned Proceed Button */}
//               <div className="flex justify-end ">
//                 <Button
//                   onClick={handleClose}
//                   className="py-2  rounded"
//                   disabled={!isFormValid}
//                   sx={{
//                     color: isFormValid ? 'gray' : 'white', // Set to gray when enabled
//                     backgroundColor: isFormValid ? 'orange' : 'gray',
//                     '&:hover': {
//                       backgroundColor: isFormValid ? 'darkorange' : 'gray',
//                     },
//                   }}
//                 >
//                   PROCEED
//                 </Button>
//               </div>
//             </div>
//           </Box>
//         </Modal>
//       </div>
//     </>
//   );
// }



// import React, { useState } from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";

// export default function Terms() {
//   const [open, setOpen] = useState(false);
//   const [termsChecked, setTermsChecked] = useState(false);
//   const [privacyChecked, setPrivacyChecked] = useState(false);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const handleTermsChange = (event) => {
//     setTermsChecked(event.target.checked);
//   };

//   const handlePrivacyChange = (event) => {
//     setPrivacyChecked(event.target.checked);
//   };

//   const isFormValid = termsChecked && privacyChecked;

//   return (
//     <>
//       <div className="flex justify-center items-center">
//         <Button
//           onClick={handleOpen}
//           className="bg-orange-600 text-white py-2 px-4 rounded"
//         >
//           Open Terms and Conditions
//         </Button>
//         <Modal open={open} onClose={handleClose} aria-labelledby="terms-title">
//           <Box
//             className="bg-white rounded-lg shadow-lg"
//             sx={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               transform: 'translate(-50%, -50%)',
//               width: { xs: '90%', sm: '80%', md: '60%', lg: '50%' },
//               maxHeight: '90vh',
//               overflowY: 'auto',
//             }}
//           >
//             <Typography
//               id="terms-title"
//               variant="h6"
//               sx={{
//                 textAlign: 'center',
//                 bgcolor: 'orange',
//                 color: 'white',
//                 py: 1,
//                 borderRadius: '4px 4px 0 0',
//               }}
//             >
//               Terms and Conditions
//             </Typography>

//             {/* Scrollable Terms and Conditions content */}
//             <Box sx={{ p: 2, color: 'text.secondary', maxHeight: '40vh', overflowY: 'auto' }}>
//               <ul className="list-disc list-inside space-y-2">
//                 <li>
//                   A ride cannot commence until and unless the required documents
//                   are uploaded and verified.{" "}
//                   <a href="#" className="text-red-600 underline">
//                     Cancellation policy
//                   </a>{" "}
//                   will apply if proper documents are not uploaded for
//                   verification.
//                 </li>
//                 <li>
//                   Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
//                   specified by the governing authority, whichever is lesser.
//                 </li>
//                 <li>
//                   Rental package does not include Fuel, Toll, State Permits or
//                   Taxes.
//                 </li>
//                 <li>
//                   Km’s included in the booking if exceeded are chargeable at a per
//                   km rate.
//                 </li>
//                 <li>
//                   Some vehicle bookings have a refundable security deposit. Refund
//                   of the same, usually takes 3-7 working days, from the date of
//                   invoice, to reflect in the source account.
//                 </li>
//                 <li>Delay Drop off Charges :</li>
//                 <li>
//                   Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.
//                 </li>
//                 <li>
//                   THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES.
//                   THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.
//                 </li>
//               </ul>
//             </Box>

//             {/* Fixed Checkboxes and Proceed Button */}
//             <Box sx={{ borderTop: 1, p: 2, display: 'flex', borderStyle:'dashed', borderColor: 'gray',flexDirection: 'column' }}>
//               <Box sx={{ display: 'flex', flexDirection: 'column'}}>
//                 <label className="flex items-center">
//                   <Checkbox checked={termsChecked} onChange={handleTermsChange} />
//                   <span>Agree to Terms and Conditions</span>
//                 </label>
//                 <label className="flex items-center">
//                   <Checkbox checked={privacyChecked} onChange={handlePrivacyChange} />
//                   <span>Agree to Privacy Policy</span>
//                 </label>
//               </Box>

//               {/* Right-aligned Proceed Button */}
//               <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//                 <Button
//                   onClick={handleClose}
//                   disabled={!isFormValid}
//                   sx={{
//                     color: isFormValid ? 'white' : 'gray',
//                     bgcolor: isFormValid ? 'orange' : 'lightgray',
//                     ':hover': {
//                       bgcolor: isFormValid ? 'darkorange' : 'lightgray',
//                     },
//                     py: 1,
//                     px: 3,
//                     borderRadius: 1,
//                   }}
//                 >
//                   PROCEED
//                 </Button>
//               </Box>
//             </Box>
//           </Box>
//         </Modal>
//       </div>
//     </>
//   );
// }


// import React from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";

// export default function Terms({ open, onClose }) {
//   const [termsChecked, setTermsChecked] = React.useState(false);
//   const [privacyChecked, setPrivacyChecked] = React.useState(false);

//   const handleTermsChange = (event) => setTermsChecked(event.target.checked);
//   const handlePrivacyChange = (event) => setPrivacyChecked(event.target.checked);

//   const isFormValid = termsChecked && privacyChecked;

//   return (
//     <Modal open={open} onClose={onClose} aria-labelledby="terms-title">
//       <Box
//         className="bg-white rounded-lg shadow-lg"
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: { xs: "90%", sm: "80%", md: "60%", lg: "50%" },
//           maxHeight: "90vh",
//           overflowY: "auto",
//         }}
//       >
//         <Typography
//           id="terms-title"
//           variant="h6"
//           sx={{
//             textAlign: "center",
//             bgcolor: "orange",
//             color: "white",
//             py: 1,
//             borderRadius: "4px 4px 0 0",
//           }}
//         >
//           Terms and Conditions
//         </Typography>
//         <Box sx={{ p: 2, color: "text.secondary", maxHeight: "40vh", overflowY: "auto" }}>
//           <ul className="list-disc list-inside space-y-2">
//             <li>A ride cannot commence until and unless the required documents are uploaded and verified.</li>
//             <li>Speed Limit for Bajaj Pulsar NS 400 is 110 kmph.</li>
//             <li>Km’s included in the booking if exceeded are chargeable at a per km rate.</li>
//             <li>Some vehicle bookings have a refundable security deposit.</li>
//           </ul>
//         </Box>
//         <Box sx={{ borderTop: 1, p: 2, display: "flex", flexDirection: "column" }}>
//           <label className="flex items-center">
//             <Checkbox checked={termsChecked} onChange={handleTermsChange} />
//             <span>Agree to Terms and Conditions</span>
//           </label>
//           <label className="flex items-center">
//             <Checkbox checked={privacyChecked} onChange={handlePrivacyChange} />
//             <span>Agree to Privacy Policy</span>
//           </label>
//           <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
//             <Button
//               onClick={onClose}
//               disabled={!isFormValid}
//               sx={{
//                 color: isFormValid ? "white" : "gray",
//                 bgcolor: isFormValid ? "orange" : "lightgray",
//                 ":hover": {
//                   bgcolor: isFormValid ? "darkorange" : "lightgray",
//                 },
//                 py: 1,
//                 px: 3,
//                 borderRadius: 1,
//               }}
//             >
//               PROCEED
//             </Button>
//           </Box>
//         </Box>
//       </Box>
//     </Modal>
//   );
// }



// import React from "react";
// import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";

// export default function Terms({ open, onClose }) {
//   const [termsChecked, setTermsChecked] = React.useState(false);
//   const [privacyChecked, setPrivacyChecked] = React.useState(false);

//   const handleTermsChange = (event) => setTermsChecked(event.target.checked);
//   const handlePrivacyChange = (event) => setPrivacyChecked(event.target.checked);

//   const isFormValid = termsChecked && privacyChecked;

//   return (
//     <Modal open={open} onClose={onClose} aria-labelledby="terms-title">
//       <Box
//         className="bg-white rounded-lg shadow-lg"
//         sx={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           width: { xs: "90%", sm: "80%", md: "60%", lg: "80" },
//           maxHeight: "90vh",
//           overflowY: "auto",
//         }}
//       >
//         <Typography
//           id="terms-title"
//           variant="h6"
//           sx={{
//             textAlign: "center",
//             bgcolor: "orange",
//             color: "white",
//             py: 1,
//             borderRadius: "4px 4px 0 0",
//           }}
//         >
//           Terms and Conditions
//         </Typography>

//         <div className="text-gray-700 p-4 max-h-72  AQSWGTFVRBHYJK overflow-y-auto text-lg">
//           <ul className="list-disc list-inside space-y-2">
//             <li>
//               A ride cannot commence until and unless the required documents
//               are uploaded and verified.{" "}
//               <a href="#" className="text-red-600 underline">
//                 Cancellation policy
//               </a>{" "}
//               will apply if proper documents are not uploaded for
//               verification.
//             </li>
//             <li>
//               Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
//               specified by the governing authority, whichever is lesser.
//             </li>
//             <li>
//               Rental package does not include Fuel, Toll, State Permits or
//               Taxes.
//             </li>
//             <li>
//               Km’s included in the booking if exceeded are chargeable at a per
//               km rate.
//             </li>
//             <li>
//               Some vehicle bookings have a refundable security deposit. Refund
//               of the same, usually takes 3-7 working days, from the date of
//               invoice, to reflect in the source account.
//             </li>
//             <li>Delay Drop off Charges :</li>
//             <li>
//               Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.
//             </li>
//             <li>
//               THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES.
//               THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.
//             </li>
//           </ul>
//         </div>
//         <Box sx={{ borderTop: 1, borderStyle: "dashed", borderColor: "gray", p: 2, display: "flex", flexDirection: "column" }}>
//           <label className="flex items-center">
//             <Checkbox checked={termsChecked} onChange={handleTermsChange} />
//             <span>Agree to Terms and Conditions</span>
//           </label>
//           <label className="flex items-center">
//             <Checkbox checked={privacyChecked} onChange={handlePrivacyChange} />
//             <span>Agree to Privacy Policy</span>
//           </label>
//           <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
//             <Button
//               onClick={onClose}
//               disabled={!isFormValid}
//               sx={{
//                 color: isFormValid ? "white" : "gray",
//                 bgcolor: isFormValid ? "orange" : "lightgray",
//                 ":hover": {
//                   bgcolor: isFormValid ? "darkorange" : "lightgray",
//                 },
//                 py: 1,
//                 px: 3,
//                 borderRadius: 1,
//               }}
//             >
//               PROCEED
//             </Button>
//           </Box>
//         </Box>
//       </Box>
//     </Modal>
//   );
// }


import React from "react";
import { Modal, Box, Typography, Button, Checkbox } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function Terms({ open, Close }) {
  const [termsChecked, setTermsChecked] = React.useState(false);
  const [privacyChecked, setPrivacyChecked] = React.useState(false);
// console.log(Close,"close vivevke");

  const handleTermsChange = (event) => setTermsChecked(event.target.checked);
  const handlePrivacyChange = (event) => setPrivacyChecked(event.target.checked);

  const isFormValid = termsChecked && privacyChecked;

  const navigate = useNavigate();

  const handleproceedandclose = () => {
    handleProceed();
    Close();
  }
  const handleProceed = () => {
    Swal.fire({
      title: "Thank you!",
      text: "Your Payment has been submitted successfully",
      icon: "success",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true, 
    }).then(() => {
     
      // onClose();
      navigate("/");
    });
  };

  return (
    <Modal open={open}  aria-labelledby="terms-title">
      <Box
        className="bg-white rounded-lg shadow-lg"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "80%", md: "60%", lg: "80" },
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography
          id="terms-title"
          variant="h6"
          sx={{
            textAlign: "center",
            bgcolor: "orange",
            color: "white",
            py: 1,
            borderRadius: "4px 4px 0 0",
          }}
        >
          Terms and Conditions
        </Typography>

        <div className="text-gray-700 p-4 max-h-72 overflow-y-auto text-lg">
          <ul className="list-disc list-inside space-y-2">
            <li>
              A ride cannot commence until and unless the required documents
              are uploaded and verified.{" "}
              <a href="#" className="text-red-600 underline">
                Cancellation policy
              </a>{" "}
              will apply if proper documents are not uploaded for
              verification.
            </li>
            <li>
              Speed Limit for Bajaj Pulsar NS 400 is 110 kmph or speed limit
              specified by the governing authority, whichever is lesser.
            </li>
            <li>
              Rental package does not include Fuel, Toll, State Permits or
              Taxes.
            </li>
            <li>
              Km’s included in the booking if exceeded are chargeable at a per
              km rate.
            </li>
            <li>
              Some vehicle bookings have a refundable security deposit. Refund
              of the same, usually takes 3-7 working days, from the date of
              invoice, to reflect in the source account.
            </li>
            <li>Delay Drop off Charges :</li>
            <li>
              Overspeeding fine of Rs. 500 is applicable after every 3 counts
              of overspeeding. This is exclusive of taxes and any other fines
              applied by the governing authority.
            </li>
            <li>
              THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF
              AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED
              PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN
              VARIOUS STATUTES. THESE TERMS OF SERVICES DOES NOT REQUIRE ANY
              PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.
            </li>
          </ul>
        </div>
        <Box
          sx={{
            borderTop: 1,
            borderStyle: "dashed",
            borderColor: "gray",
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label className="flex items-center">
            <Checkbox checked={termsChecked} onChange={handleTermsChange} />
            <span>Agree to Terms and Conditions</span>
          </label>
          <label className="flex items-center">
            <Checkbox checked={privacyChecked} onChange={handlePrivacyChange} />
            <span>Agree to Privacy Policy</span>
          </label>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleproceedandclose}
              disabled={!isFormValid}
              // onClose={Close}
              sx={{
                color: isFormValid ? "white" : "gray",
                bgcolor: isFormValid ? "orange" : "lightgray",
                ":hover": {
                  bgcolor: isFormValid ? "darkorange" : "lightgray",
                },
                py: 1,
                px: 3,
                borderRadius: 1,
              }}
            >
              PROCEED
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}



























